import pusher from './pusher.js';
import { api } from 'boot/axios.js';
import { formsDB } from 'src/services/indexedDB/formsDB';

class WebsocketService {
  constructor() {
    this.channels = {};
    this.initialized = false;
  }

  /**
   * Initialize the websocket service
   */
  init() {
    if (this.initialized) return;
    this.initialized = true;
    this.subscribeToMalawiWebsockets();
  }

  /**
   * Subscribe to the Malawi websockets channel
   */
  subscribeToMalawiWebsockets() {
    const channelName = 'malawi-websockets';
    const channel = pusher.subscribe(channelName);
    this.channels[channelName] = channel;

    channel.bind('clientHasChanged', async (data) => {
      await this.handleClientChanged(data);
    });
  }

  /**
   * Handle the clientHasChanged event
   * @param {Object} data - The event data
   */
  async handleClientChanged(data) {
    const serverData = JSON.parse(data.message);

    console.log('data:', serverData);

    if (!serverData) return;
    console.log('serverData:', serverData.appID);
    console.log('localStorage APP-ID:', localStorage.getItem('APP-ID'));

    if (serverData.appID == localStorage.getItem('APP-ID')) return;

    try {
      let formData = new FormData();
      formData.append('mutatedRecords', JSON.stringify(serverData.mutatedRecords));
      let response = await api.post('/api/requestMutatedRecords', formData);

      console.log('response:', response);

      response.data.forEach(async (record) => {
        await this.processRecord(record);
      });
    } catch (error) {
      console.error('Error fetching data from server:', error);
      return;
    }
  }

  /**
   * Process a record received from the server
   * @param {Object} record - The record to process
   */
  async processRecord(record) {
    try {
      const { table, uuid } = record;

      if (table === 'rehabilitations') {
        // Check if the record exists in the Dexie.js database
        const existingRecord = await formsDB.rehabilitations.where({ uuid }).first();

        if (existingRecord) {
          // Update the existing record
          console.log(`Updated record with UUID: ${uuid}`);
          await formsDB.rehabilitations.put({ ...existingRecord, ...record.recordcontent });
        } else {
          // Add the new record
          console.log(`Added new record with UUID: ${uuid}`);
          delete record.recordcontent.id
          await formsDB.rehabilitations.add(record.recordcontent);
        }
      }
    } catch (error) {
      console.error(`Error processing record with UUID: ${record.uuid} ]`, error);
      console.log(error.stack);
    }
  }

  /**
   * Clean up websocket connections
   */
  cleanup() {
    for (const channelName in this.channels) {
      const channel = this.channels[channelName];
      if (channel) {
        if (channelName === 'malawi-websockets') {
          channel.unbind('clientHasChanged');
        }
        pusher.unsubscribe(channelName);
      }
    }
    this.channels = {};
    this.initialized = false;
  }
}

// Create and export a singleton instance
const websocketService = new WebsocketService();
export default websocketService;